import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import log from '../services/logger/log';
import {selectCaptivePortalPage} from '../state/selectors/monitoring';

const useLogNavigation = () => {
    const captivePortalPage = useSelector(selectCaptivePortalPage);
    const {pathname} = useLocation();

    useEffect(() => {
        if (captivePortalPage) {
            log.debug(`useLogNavigation: Captive Portal. User navigated to: ${captivePortalPage}`);
        }
    }, [captivePortalPage]);

    useEffect(() => {
        log.debug(`useLogNavigation: User navigated to: ${pathname}`);
    }, [pathname]);
};

export default useLogNavigation;
